import { render } from "./DeletePriceChargeConfirmationModal.vue?vue&type=template&id=13b4b3ef&ts=true"
import script from "./DeletePriceChargeConfirmationModal.vue?vue&type=script&lang=ts"
export * from "./DeletePriceChargeConfirmationModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__